module.exports = __webpack_public_path__ + "img/liushaoxuan.865a1a89.png";